"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _system = require("@/api/system");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'agreements',
  components: {
    Tinymce: _index.default
  },
  data: function data() {
    return {
      loading: false,
      tabList: [{
        title: '用户协议',
        id: 1,
        info: 'userinfo',
        save: 'usersave'
      }, {
        title: '隐私协议',
        id: 2,
        info: 'userprivacyinfo',
        save: 'userprivacysave'
      }, {
        title: '入驻协议',
        id: 3,
        info: 'merincomminginfo',
        save: 'merincommingsave'
      }, {
        title: '关于我们',
        id: 4,
        info: 'aboutusinfo',
        save: 'aboutussave'
      }, {
        title: '资质证照',
        id: 5,
        info: 'intelligentinfo',
        save: 'intelligentsave'
      }, {
        title: '平台规则',
        id: 6,
        info: 'platfromruleinfo',
        save: 'platfromrulesave'
      }, {
        title: '注销协议',
        id: 7,
        info: 'useraccountcancelinfo',
        save: 'useraccountcancelsave'
      }, {
        title: '注销声明',
        id: 8,
        info: 'useraccountcancelnoticeinfo',
        save: 'useraccountcancelnoticesave'
      }, {
        title: '优惠券协议',
        id: 8,
        info: 'coupon/agreement/info',
        save: 'coupon/agreement/save'
      }, {
        title: '付费会员协议',
        id: 8,
        info: 'paid/member/info',
        save: 'paid/member/save'
      }],
      formValidate: {
        agreement: ''
      },
      agreementValue: 'userinfo',
      agreementSave: 'usersave',
      keyIndex: 0
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:system:agreement:user:info', 'platform:system:agreement:merincomming:info', 'platform:system:agreement:userprivacy:info', 'platform:system:agreement:useraccountcancel:info', 'platform:system:agreement:useraccountcancelnotice:info', 'platform:system:agreement:aboutus:info', 'platform:system:agreement:intelligent:info', 'platform:system:agreement:platfromrule:info', 'platform:system:agreement:coupon:agreement:info', 'platform:system:agreement:paid:member:info'])) this.getInfo(this.agreementValue);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getInfo: function getInfo(data) {
      var _this = this;
      this.loading = true;
      this.formValidate.agreement = '';
      (0, _system.agreementInfoApi)(data).then(function (res) {
        _this.formValidate.agreement = res ? JSON.parse(res).agreement : '';
        _this.keyIndex += 1;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    submenus: function submenus() {
      var _this2 = this;
      if (this.formValidate.agreement === '' || !this.formValidate.agreement) {
        return this.$message.warning('请输入协议信息！');
      } else {
        (0, _system.agreementSaveApi)(this.agreementSave, this.formValidate).then(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _this2.$message.success('保存成功');
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    },
    tabStatus: function tabStatus(e) {
      this.getInfo(e.name);
      this.agreementSave = this.tabList[e.index].save;
    }
  }
};